import React from "react";
import locale from "./errorPanel.locale";
const errorCodeStyle = {
    fontSize: "9.5em",
    fontWeight: 500,
    lineHeight: 1
};
const errorDescriptionStyle = {
    marginTop: "0.75em",
    fontSize: "2.5em",
    fontWeight: 300
};
const errorDescriptionMiniStyle = {
    fontSize: "1.4em",
    fontWeight: 300
};
export default function ErrorPanel(props) {
    return (React.createElement("div", { className: "flex-box-centered-content w-100 text-gray-700" },
        React.createElement("div", { className: "text-center" },
            React.createElement("div", { style: errorCodeStyle }, props.code),
            React.createElement("div", { style: errorDescriptionStyle }, props.title),
            React.createElement("div", { style: errorDescriptionMiniStyle }, locale.DESCRIPTION))));
}
ErrorPanel.defaultProps = {
    title: locale.TITLE,
    code: locale.ERROR_CODE
};
